import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Azuredeveloptemplate extends Component {
 
  render() {
    const course =[


        {
          title : "Introduction to Azure Development",
          content: [
          "Overview of Azure and cloud computing",
          "Azure services and solutions",
          "Developing applications for Azure",
          "Azure developer tools and SDKs",
          "Azure Portal and CLI"
          ]
          },
          {
          title: "Azure Infrastructure as a Service (IaaS)",
          content: [
          "Creating and managing virtual machines",
          "Configuring virtual networks and storage",
          "Scaling and managing virtual machines",
          "Using Azure Site Recovery",
          "Migrating to Azure IaaS"
          ]
          },
          {
          title: "Azure Platform as a Service (PaaS)",
          content: [
          "Azure Web Apps and Azure Functions",
          "Azure App Service plans",
          "Azure Cosmos DB and Azure SQL Database",
          "Azure Blob Storage and Azure Queue Storage",
          "Azure Service Bus and Azure Event Grid"
          ]
          },
          {
          title: "Securing Azure Solutions",
          content: [
          "Azure Active Directory",
          "Managing identities and authentication",
          "Securing data and applications",
          "Implementing Azure Security Center",
          "Managing Azure Key Vault"
          ]
          },
          {
          title: "Deploying and Managing Azure Solutions",
          content: [
          "Creating and managing Azure Resource Manager templates",
          "Deploying and managing Azure resources",
          "Configuring and managing Azure virtual networks",
          "Monitoring and analyzing Azure resources",
          "Creating and managing Azure Kubernetes Service (AKS) clusters"
          ]
          },
          {
          title: "Developing for Azure Storage",
          content: [
          "Introduction to Azure Storage",
          "Azure Blob Storage and Azure Queue Storage",
          "Azure Table Storage and Azure File Storage",
          "Managing and accessing Azure Storage",
          "Developing for Azure Storage using .NET"
          ]
          },
          {
          title: "Developing for Azure Compute",
          content: [
          "Azure Functions and Azure Web Jobs",
          "Creating and deploying Azure Functions",
          "Working with Azure Logic Apps",
          "Creating and managing Azure Batch",
          "Working with Azure Container Instances"
          ]
          },
          {
          title: "Developing Azure Cognitive Services Solutions",
          content: [
          "Introduction to Azure Cognitive Services",
          "Working with Azure Text Analytics",
          "Working with Azure Speech Services",
          "Working with Azure Vision Services",
          "Integrating Azure Cognitive Services into applications"
          ]
          },
          {
          title: "Developing for Azure IoT and Edge Devices",
          content: [
          "Introduction to Azure IoT and Edge devices",
          "Working with Azure IoT Hub",
          "Working with Azure IoT Edge",
          "Developing for Azure Stream Analytics",
          "Implementing Azure Event Hubs and Azure Notification Hubs"
          ]
          },
          {
          title: "Azure DevOps and Continuous Integration/Continuous Delivery (CI/CD)",
          content: [
          "Introduction to Azure DevOps and CI/CD",
          "Creating and managing Azure DevOps projects",
          "Implementing Azure DevOps build pipelines",
          "Implementing Azure DevOps release pipelines",
          "Using Azure Artifacts"
          ]
          },
          {
          title: "Monitoring, Troubleshooting, and Optimizing Azure Solutions",
          content: [
          "Introduction to Azure Monitoring",
          "Using Azure Monitor for infrastructure and application monitoring",
          "Troubleshooting Azure solutions",
          "Optimizing Azure solutions",
          "Using Azure Advisor and Azure Service Health"
          ]
          },
          {
            title: "Advanced Azure Development",
            content: [
            "Building cloud-native applications with Azure Kubernetes Service (AKS)",
            "Developing solutions with Azure Event Grid and Event Hubs",
            "Developing Azure Cognitive Services solutions",
            "Developing solutions with Azure Search",
            "Integrating AI and machine learning in Azure solutions"
            ]
            }
    ]

    const faqData = [
      {
        question: 'What is Azure developer training, and who is it suitable for?',
        answer:
          'Azure developer training is a program designed to equip individuals with the skills and knowledge required to develop and deploy applications on Microsoft Azure cloud platform. It is suitable for developers, IT professionals, and software engineers aiming to enhance their expertise in cloud application development.',
      },
      {
        question: 'What can I expect to learn in Azure developer training at the best training centre?',
        answer:
          'In Azure developer training at the best training centre, you will learn various aspects of Azure development, including Azure services, Azure App Service, Azure Functions, Azure Storage, Azure SQL Database, Azure DevOps, and more. You will gain hands-on experience in building, deploying, and managing applications on Azure.',
      },
      {
        question: 'What are some common use cases for Azure Developers?',
        answer:
          'Common use cases for Azure Developers include developing and deploying web applications, creating and managing databases, integrating Azure services with other applications and services, and building and deploying artificial intelligence and machine learning models on the Azure platform.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          "A person with Azure Developer skills can pursue a variety of career opportunities such as Azure Developer, Cloud Application Developer, Web Developer, Full-Stack Developer, and Solutions Architect.",
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To embark on Azure Developer training at the best training centre, individuals should possess a fundamental understanding of cloud computing concepts and programming languages such as C#, Python, or JavaScript. Whether you're an aspiring developer, IT professional, or software engineer looking to specialize in cloud application development, our Azure Developer training program caters to learners at all skill levels. Prior experience with Microsoft Azure services and tools is beneficial but not mandatory, as our comprehensive curriculum covers everything from Azure fundamentals to advanced development techniques. Join us at the best training centre to gain the expertise and hands-on experience needed to build and deploy scalable, secure, and efficient cloud-based applications on the Azure platform."
      },

    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    return(
      <>
     
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="An Azure developer is a professional who specializes in developing and deploying applications on the Microsoft Azure cloud platform. Azure developers leverage Azure services such as Azure App Service, Azure Functions, Azure Storage, Azure Cosmos DB, and Azure SQL Database, and tools to build scalable, reliable, and secure cloud-based applications that meet the specific needs of businesses."/> */}
          <NewMainsec rating='4.7' students={"343"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="An Azure developer is a professional who specializes in developing and deploying applications on the Microsoft Azure cloud platform. Azure developers leverage Azure services such as Azure App Service, Azure Functions, Azure Storage, Azure Cosmos DB, and Azure SQL Database, and tools to build scalable, reliable, and secure cloud-based applications that meet the specific needs of businesses."/>
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Get the best Azure Developer ${this.props.location1} with Learnsoft.org. Azure development is in high demand and professionals with Azure development skills are in great demand. Our Azure Developer training courses in ${this.props.location} are designed to help you enhance your skills and gain a comprehensive understanding of Azure development principles and practices. Our experienced trainers use a hands-on approach and real-world scenarios to provide a well-rounded education. Enroll in our Azure Developer ${this.props.location1} today and take your career to the next level.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Azure Developer course in Chennai covers a wide range of topics, including cloud infrastructure, app development, and deployment. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Azure development. By the end of the course, you will be able to implement Azure development practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
          <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou3="DevOps" coupath3="devops" cou='Azure DevOps' coupath='azure-devops' cou1='Azure Administration' coupath1='azure-admin' cou5='Azure Solution Architect' coupath5='azure-solution-architect' cou2='Azure Data Engineering' coupath2='azure-data-engineering'
          cou9='Kubernetes' coupath9='kubernetes' cou8='Jenkins' coupath8='jenkins' cou7='GoCD' coupath7='gocd'
          cou10='Terraform' coupath10='terraform' cou4='Azure Training' coupath4='azure'  cou6='Azure Security' coupath6='azure-security' />

      </>
    );
  }
}
